export default "__VITE_ASSET__G91ySkbK__"